/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EvaluationScoreListInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EvaluationScoreListApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EvaluationScoreLists');
  }

  updateEvaluationScoreList(
    evaluationScoreListUpdate: Partial<EvaluationScoreListInterface>
  ): Observable<EvaluationScoreListInterface> {
    const path = `update-evaluation-score-list`;
    return this.patch(path, undefined, evaluationScoreListUpdate);
  }
}
